import React from 'react';

export const NotFound = () => {
  return (
    <div className='container'>
      <h1>404, Not Found</h1>
      <p>Sorry, looks like there&apos;s nothing here.</p>
    </div>
  );
};

export default NotFound;
